<template>
  <div class="main-container matriz-iperc">
    
    <div v-show="!showTarea && !showResult">
      <div class="ingresar-datos" v-show="showIngresarDatos">
        <input type="text" class="input-empresa" placeholder="Nombre de la empresa" v-model="newCorporation" />
        <input type="text" class="input-ruc" v-model="newRUC" placeholder="RUC" />
      </div>

      <div class="ingresar-proceso" v-show="showIngresarProceso">
        <button ref="processNameButton" class="process-name" contenteditable="true">
          {{ processName }}
        </button>
        <button @click="openModal">+</button>
      </div>

      <div class="actividades-container" v-show="showActividades">
        <div>
          <h2>ACTIVIDADES</h2>
          <button class="btn-agregar-actividad" @click="addActivity">+</button>
        </div>
        <table class="actividades-table">
          <tr v-for="(activity, index) in filteredActivities" :key="activity.id">
            <td>{{ activity.name }}</td>
            <td>
              <button 
                class="btn-editar" 
                :class="{ 'shining-effect': activity.isNew }" 
                @click="openActivityConfig(activity)" 
                :disabled="!activity.enabled"
              >
                <img src="@/assets/img/editar.png" alt="editar" />
              </button>
            </td>
            <td>
              <button class="btn-eliminar" @click="deleteActivity(index)">
                <img src="@/assets/img/eliminar.png" alt="eliminar" />
              </button>
            </td>
          </tr>
        </table>
        <button class="btn-ejecutar" @click="processResults" :disabled="allButtonsDisabled">Ejecutar</button>
      </div>
    </div>

    <div class="nuevo-contenedor" v-show="showTarea">
      <div class="regresar">
        <button class="btn-regresar" @click="goBack">
          <div><img src="@/assets/img/flecha.png" alt="" /></div>
          <div>Regresar a LISTA DE ACTIVIDADES</div>
        </button>
      </div>

      <div class="nuevo-contenido layout-centrado">
        <div class="wizard-progress">
          <div class="step" :class="{ active: step >= 1 }">1. Base</div>
          <div class="line" :class="{ filled: step >= 2 }"></div>
          
          <div class="step" :class="{ active: step >= 2 }">2. Inherente</div>
          <div class="line" :class="{ filled: step >= 3 }"></div>
          
          <div class="step" :class="{ active: step >= 3 }">3. Control</div>
          <div class="line" :class="{ filled: step >= 4 }"></div>

          <div class="step" :class="{ active: step >= 4 }">4. Residual</div>
        </div>

        <div class="phase-indicator" v-if="step === 2 || step === 4">
          <div class="phase-badge" :class="currentEvaluationPhase">
            <svg v-if="step === 2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <svg v-else-if="step === 4" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
            <span class="phase-text">{{ phaseTitle }}</span>
          </div>
          <p class="phase-description">{{ phaseDescription }}</p>
        </div>

        <div v-show="step === 1" class="form-wrapper">
          <ActivityForm 
            ref="formActivity" 
            @activity="handleActivity" 
            :cleanAll="cleanAll"
          ></ActivityForm>
        </div>

        <div class="controls-summary" v-if="step === 4 && operationalControl">
            <div class="summary-header">
                <span>🛡️ Recordatorio: Controles Aplicados</span>
            </div>
            <div class="summary-list">
                <div v-if="operationalControl.eliminacion"><strong>Eliminación:</strong> {{ operationalControl.eliminacion }}</div>
                <div v-if="operationalControl.sustitucion"><strong>Sustitución:</strong> {{ operationalControl.sustitucion }}</div>
                <div v-if="operationalControl.controlIngenieria"><strong>Ingeniería:</strong> {{ operationalControl.controlIngenieria }}</div>
                <div v-if="operationalControl.controlAdministrativo"><strong>Admin:</strong> {{ operationalControl.controlAdministrativo }}</div>
                <div v-if="operationalControl.EPPs"><strong>EPPs:</strong> {{ operationalControl.EPPs }}</div>
            </div>
        </div>

        <div v-show="step === 2 || step === 4" class="form-wrapper">
          <EvaluationForm 
            ref="formEval"
            :key="step"
            @risk-evaluation="handleEvaluationRisk" 
            :cleanAll="cleanAll" 
            :risk="risks_id"
            :evaluationType="currentEvaluationPhase">
          </EvaluationForm>
        </div>

        <div v-show="step === 3" class="form-wrapper">
          <ControlForm 
            ref="formControl"
            @operational-control="handleOperationalControl" 
            :cleanAll="cleanAll">
          </ControlForm>
        </div>

        <div class="smart-button-container">
          <button class="btn-smart" @click="handleSmartAction" :disabled="isLoading">
            {{ smartButtonText }}
          </button>
        </div>
      </div>
    </div>

    <ContainedModal
      :isOpen="showProcessModal"
      @updateModal="showProcessModal = $event"
      :styleObject="{ width: '306px', height: '182px' }"
    >
      <div class="modal-content1">
        <h2>INGRESA UN NOMBRE PARA EL PROCESO</h2>
        <input type="text" v-model="newProcessName" placeholder="NOMBRE (PROCESO)" />
        <button @click="confirmProcessName" class="close">Listo</button>
      </div>
    </ContainedModal>

    <IpercResult 
      :matrix_id="matrix_id" 
      :newProcessName="newProcessName" 
      :newRUC="newRUC" 
      :newCorporation="newCorporation"
      v-if="showResult"
      @resetMatrix="resetMatrix">
    </IpercResult> 
  </div>
</template>

<script>
import ContainedModal from "./ContainedModal.vue";
import ControlForm from "./ControlForm.vue";
import IpercResult from "./IpercResult.vue";
import EvaluationForm from "./EvaluationForm.vue";
import ActivityForm from "./ActivityForm.vue";

export default {
  name: "MatrizIperc",
  components: {
    ContainedModal,
    ControlForm,
    IpercResult,
    EvaluationForm,
    ActivityForm
  },
  data() {
    return {
      newCorporation: "",
      newRUC: "",
      newProcessName: "",
      processName: "PROCESO",      
      showIngresarDatos: true,
      showIngresarProceso: true,
      showActividades: false,
      showTarea: false,       
      showResult: false,
      showProcessModal: false,
      isLoading: false,
      cleanAll: false,
      activities: [],
      
      matrix_id: 0,
      processes_id: 0,
      risks_id: 0,
      iperc_id: 0, 
      tasks_id: 0, dangers_id: 0, consequences_id: 0, 

      iperc: null,
      inherentRiskEval: null,
      residualRiskEval: null,
      operationalControl: null,

      step: 1,
      currentActivity: null, 
    };
  },
  methods: {
    handleSmartAction() {
      if (this.isLoading) return;

      if (this.step === 1) {
        if (this.$refs.formActivity) this.$refs.formActivity.submitForm();
      } 
      else if (this.step === 2 || this.step === 4) {
        if (this.$refs.formEval) this.$refs.formEval.submitForm();
      } 
      else if (this.step === 3) {
        if (this.$refs.formControl) this.$refs.formControl.submitForm();
      }
      else {
        this.processResults();
      }
    },

    async handleActivity(ipercData) {
      this.iperc = ipercData;
      this.isLoading = true;
      try {
        const [taskId, dangerId, riskId, consequenceId] = await Promise.all([
          this.createEntity('/chatbot/task', { description: this.iperc.newTask }, 'task'),
          this.createEntity('/chatbot/danger', { description: this.iperc.newDanger }, 'danger'),
          this.createEntity('/chatbot/risk', { description: this.iperc.newRisk }, 'risk'),
          this.createEntity('/chatbot/consequence', { description: this.iperc.newConsequence }, 'consequence')
        ]);

        this.tasks_id = taskId;
        this.dangers_id = dangerId;
        this.risks_id = riskId;
        this.consequences_id = consequenceId;

        const iperx = {
          matrix_id: this.matrix_id,
          places_id: this.iperc.selectedLugar,
          processes_id: this.processes_id,
          tasks_id: this.tasks_id,
          work_positions_id: this.iperc.selectedPosicion,
          risks_id: this.risks_id,
          dangers_id: this.dangers_id,
          consequences_id: this.consequences_id,
          type: this.iperc.selectedType,
          routine: (this.iperc.routine === true) ? "Y" : "N"
        };

        this.iperc_id = await this.createEntity('/chatbot/iperc', iperx, 'iperc');
        
        this.step = 2; 
        
      } catch (error) {
        alert("Error al guardar datos base.");
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    handleEvaluationRisk(value){
      console.log(`Evaluación (Step ${this.step}) recibida:`, value);
      this.isLoading = true;

      const evluationRisk = {
         risks_id: this.risks_id, 
         index_a: value.index_a, index_b: value.index_b, index_c: value.index_c, index_d: value.index_d,
         severity: value.severity, signification: (value.signification ? 1 : 0), 
         type: value.newRiskType 
      };
      
      this.createEntity('/chatbot/risk-evaluation', evluationRisk, 'riskEvaluation')
        .then(() => {
            if (this.step === 2) {
              this.inherentRiskEval = value; 
              alert("Evaluación Inherente guardada. Defina Controles.");
              this.step = 3; 
            } else {
              this.residualRiskEval = value;

              if (this.currentActivity) {
                this.currentActivity.completed = true;
              }

              alert("¡Actividad completada con éxito!");
              this.goBack();
            }
        })
        .catch(e => console.error(e))
        .finally(() => this.isLoading = false);
    },

    handleOperationalControl(value) {
      console.log("Controles recibidos:", value);
      this.isLoading = true;
      
      const control = {
         iperc_id: this.iperc_id, 
         elimination: value.eliminacion, sustitution: value.sustitucion,
         engineering_control: value.controlIngenieria, admin_control: value.controlAdministrativo, 
         epps: value.EPPs
      };
      
      this.createEntity('/chatbot/operational-control', control, 'operationalControl')
        .then(() => {
           this.operationalControl = value;
           alert("Controles guardados. Realice Evaluación Residual.");
           this.step = 4; 
        })
        .catch(e => console.error(e))
        .finally(() => this.isLoading = false);
    },

    async createEntity(endpoint, payload, entityName) {
      const response = await this.$axios.post(endpoint, payload);
      if (response.data[entityName]?.id) return response.data[entityName].id;
      return response.data;
    },
    
    createMatrix() {
      this.$axios.post(`/chatbot/matrix`, { corporation: this.newCorporation, ruc: this.newRUC })
        .then(res => this.matrix_id = res.data.matrix.id);
    },
    createProcess() {
      this.$axios.post(`/chatbot/process`, { name: this.newProcessName })
        .then(res => this.processes_id = res.data.process.id);
    },
    addActivity(){
      this.cleanAll = false;
      this.activities.push({ 
        id: Date.now(), 
        name: `Actividad ${this.activities.length + 1}`, 
        enabled: true,
        isNew: true,
        completed: false
      });
    },

    openActivityConfig(activity) {
      activity.isNew = false;
      this.editActivity();
      this.currentActivity = activity;
    },
    deleteActivity(index){ this.activities.splice(index, 1); },
    
    editActivity() {
      this.cleanAll = false;
      this.iperc_id = 0;
      this.tasks_id = 0; this.dangers_id = 0; this.risks_id = 0; this.consequences_id = 0;
      this.inherentRiskEval = null;
      this.operationalControl = null;
      this.residualRiskEval = null;
      this.step = 1; 
      this.showIngresarDatos = false;
      this.showIngresarProceso = false;
      this.showActividades = false;
      this.showTarea = true;     
    },
    
    goBack() {
      this.showIngresarDatos = true;
      this.showIngresarProceso = true;
      this.showActividades = true;
      this.showTarea = false;
      this.cleanAll = true; 
      this.step = 1; 
    },
    
    processResults(){
      this.showIngresarDatos = false;
      this.showIngresarProceso = false;
      this.showActividades = false;
      this.showResult = true;
    },
    openModal() { this.showProcessModal = true; },
    confirmProcessName() {
      if (this.newProcessName.trim() !== "") {
        this.createProcess(); this.createMatrix();
        this.processName = this.newProcessName.toUpperCase();
        this.showProcessModal = false;
        this.addActivity();
        this.showActividades = true;
      }
    },
    // Pega esto dentro de methods en MatrizIperc.vue
    resetMatrix() {
      if(!confirm("¿Deseas crear una nueva matriz? Se limpiará la vista actual.")) return;

      // 1. Limpiar datos de entrada
      this.newCorporation = "";
      this.newRUC = "";
      this.newProcessName = "";
      this.processName = "PROCESO";
      this.activities = [];
      
      // 2. Limpiar IDs y objetos
      this.matrix_id = 0;
      this.processes_id = 0;
      this.risks_id = 0;
      this.iperc_id = 0;
      this.tasks_id = 0;
      this.dangers_id = 0;
      this.consequences_id = 0;
      
      this.iperc = null;
      this.inherentRiskEval = null;
      this.residualRiskEval = null;
      this.operationalControl = null;

      // 3. Resetear flujo visual
      this.step = 1;
      this.showResult = false;
      this.showTarea = false;
      this.showActividades = false;
      
      // 4. Volver al inicio
      this.showIngresarDatos = true;
      this.showIngresarProceso = true;
      this.cleanAll = true; 
    },
  },
  computed: {
      filteredActivities() { return this.activities; },
      allButtonsDisabled() {
       const hasCompletedActivity = this.activities.some(a => a.completed === true);
       return !this.newCorporation || !this.newRUC || !hasCompletedActivity ;
    },
      
      currentStep() {
        return this.step;
      },

      phaseTitle() {
        if (this.step === 2) return "EVALUACIÓN DE RIESGO INHERENTE";
        if (this.step === 4) return "EVALUACIÓN DE RIESGO RESIDUAL";
        return "";
      },

      phaseDescription() {
        if (this.step === 2) {
          return "Evalúe el riesgo puro de la actividad SIN considerar controles existentes.";
        }
        if (this.step === 4) {
          return "Evalúe el riesgo DESPUÉS de haber aplicado los controles operacionales.";
        }
        return "";
      },
      
      smartButtonText() {
        if (this.isLoading) return "GUARDANDO...";
        
        switch (this.step) {
          case 1: return "GUARDAR Y CONTINUAR"; 
          case 2: return "SIGUIENTE"; 
          case 3: return "SIGUIENTE";
          case 4: return "FINALIZAR";
          default: return "COMPLETADO";
        }
      },

      currentEvaluationPhase() {
          return this.step === 2 ? 'inherent' : 'residual';
      }
  },
};
</script>

<style scoped>

.matriz-iperc .ingresar-datos {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.ingresar-datos input {
  border: 1.5px solid #f8bc02;
  border-radius: 5px;
}

.ingresar-datos input:focus {
  outline: none;
}

.ingresar-datos input::placeholder {
  font-family: "Anek Latin", sans-serif;
  font-weight: 300;
  font-size: 15px;
  text-align: left;
  color: #b9b9b9;
  padding: 0px 10px;
}

.matriz-iperc .ingresar-datos input:nth-child(1) {
  width: 220px;
  height: 30px;
  margin: 2px;
}

.matriz-iperc .ingresar-datos input:nth-child(2) {
  width: 108px;
  height: 30px;
  margin: 2px;
}

.ingresar-proceso {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.ingresar-proceso button {
  font-family: "Anek Latin", sans-serif;
  font-weight: 600;
  font-size: 20px;
  border: 1.5px solid #f8bc02;
  background: #ffffff;
  color: #f8bc02;
  border-radius: 8px;
  cursor: pointer;
}

.ingresar-proceso button:nth-child(1) {
  width: 154.85px;
  height: 40.4px;
  margin: 2px;
}

.ingresar-proceso button:nth-child(2) {
  width: 38.47px;
  height: 40.4px;
  margin: 2px;
  font-weight: 800;
}

.modal-content1 {
  background: #f8bc02;
  width: 306px;
  height: 182px;
  text-align: center;
  border-radius: 20px;
  display: flex;
  border: 3px solid white;
  padding: 13px 0px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  align-content: space-between;
}

.modal-content1 h2 {
  font-size: 15px;
  font-family: "Anek Latin", sans-serif;
  font-weight: 500;
  color: white;
  width: 140px;
  height: auto;
  margin-top: 11px;
  text-align: center;
}

.modal-content1 input {
  border: 1px solid #b9b9b9;
  width: 254px;
  height: 40px;
  border-radius: 10px;
  margin-top: -41px;
  background-color: white;
}

.modal-content1 input::placeholder {
  font-family: "Anek Latin", sans-serif;
  text-align: center;
  font-size: 20px;
  color: black;
  font-weight: 700;
}

.modal-content1 input:focus {
  outline: none;
}

.modal-content1 button {
  border: 2px solid white;
  background: #f8bc02;
  margin-top: 21px;
  width: 93px;
  height: 30px;
  border-radius: 10px;
  color: white;
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  margin-top: -40px;
  opacity: 1;
}

.actividades-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 363px;
  position: relative;
}

.actividades-container div {
  display: flex;
  align-items: center;
  margin-top: 15px;
}

.actividades-container h2 {
  font-family: "Anek Latin", sans-serif;
  font-weight: 600;
  font-size: 15px;
  margin: 3px;
}

.actividades-container .btn-agregar-actividad {
  margin: 3px;
  border: 1px solid #f8bc02;
  border-radius: 10px;
  background: white;
  font-weight: 900;
  color: #f8bc02;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.actividades-container .actividades-table {
  margin-top: 14px;
}

.actividades-container .actividades-table td {
  border: 1px solid #f8bc02;
}

.actividades-container .actividades-table td:nth-child(1) {
  width: 276px;
  height: 26px;
  text-align: center;
  font-family: Montserrat;
  font-size: 10px;
  font-weight: 700;
}

.actividades-container .actividades-table button:hover {
  background: #f8bc02;
}

.actividades-container .btn-editar {
  width: 26px;
  height: 26px;
  background: white;
  border: none;
  cursor: pointer;
}

.actividades-container .btn-editar img {
  width: 13.13px;
  height: 15.01px;
}

.actividades-container .btn-editar:disabled{
  background: #f8bc02;
  opacity: 0.5;
}

.actividades-container .btn-ejecutar {
  background: #f8bc02;
  position: absolute;
  bottom: 35px;
  border-radius: 5px;
  color: #fff;
  width: 204px;
  height: 40px;
  font-family: "Anek Latin", sans-serif;
  font-size: 20px;
  font-weight: 600;
  border: none;
}

.actividades-container .btn-ejecutar:disabled {
  opacity: 0.5;
}

.actividades-container .btn-eliminar {
  background: white;
  border: none;
  cursor: pointer;
  width: 26px;
  height: 26px;
}

.actividades-container .btn-eliminar img {
  width: 13.13px;
  height: 13.13px;
}


.nuevo-contenedor {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  margin-top: -20px;
}

.nuevo-contenedor .btn-regresar {
  width: 338px;
  display: flex;
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #f8bc02;
  background: white;
  border: none;
  justify-content: flex-start;
  margin: 12px 0px;
  cursor: pointer;
}

.nuevo-contenedor .btn-regresar img {
  margin-right: 8px;
}

/* Contenedor principal del Wizard */
.nuevo-contenido {
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  width: 100%;
  padding-bottom: 20px; /* Asegura scroll si es necesario */
}


.layout-centrado {
  display: flex;
  flex-direction: column;
  align-items: center; 
  justify-content: flex-start;
  width: 100%;
  max-width: 100%; 
}


.wizard-progress {
  display: flex;
  justify-content: space-between; 
  align-items: center;
  margin-top: 15px;
  margin-bottom: 25px; 
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  font-family: "Anek Latin", sans-serif;

  /* --- CAMBIOS PARA JUNTAR LOS PASOS --- */
  max-width: 500px;   /* 1. Limitamos el ancho máximo  */
  margin-left: auto;  /* 2. Centramos la barra horizontalmente */
  margin-right: auto; /* 3. Centramos la barra horizontalmente */
  /* ------------------------------------ */
  
  padding: 0 10px; /* Reducimos un poco el padding lateral */
}

.wizard-progress .step {
  background: #fff;
  color: #ccc;
  border: 1.5px solid #ccc;
  padding: 6px 13px;   
  border-radius: 15px; 
  font-size: 13px;
  font-weight: 700;
  transition: all 0.3s ease;
  z-index: 2;
  white-space: nowrap; 
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.wizard-progress .step.active {
  background: #f8bc02;
  color: white;
  border-color: #f8bc02;
  box-shadow: 0 2px 4px rgba(248, 188, 2, 0.25);
}

.wizard-progress .line {
  flex : 1;
  height: 2px;
  background: #ccc;
  margin: 0 2px;
  
}

.wizard-progress .line.filled {
  background: #f8bc02;
}


.smart-button-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  
  padding-bottom: 0px; 
  margin-bottom: 50px;
  width: 100%;
}

.btn-smart {
  background: white;
  border: 2px solid #f8bc02;
  color: #f8bc02;
  width: 332px; 
  height: 48px;
  border-radius: 10px;
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05); 
}

.btn-smart:hover {
  background: #f8bc02;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(248, 188, 2, 0.2);
}

.btn-smart:active {
  transform: scale(0.98);
}


.nuevo-contenido button{
  width: 161px;
  height: 48px;
  font-family: "Anek Latin", sans-serif;
  font-size: 15px;
  color: white;
  background: #f8bc02;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  padding: 0px 20px;
  margin-bottom: 10px;
  margin-right: 4px;
  cursor: pointer;
}

.nuevo-contenido button:disabled {
  opacity: 0.5;
}

.nuevo-contenido form {
  display: flex;
  flex-direction: column;
  width: 332px;
  line-height: 22px;
  text-align: left;
}

.nuevo-contenido form input {
  width: 332px;
  height: 25px;
  background: #eeeeee;
  border: 1px solid #ababab;
  border-radius: 4px;
}

.nuevo-contenido input::placeholder {
  font-family: "Anek Latin", sans-serif;
  font-weight: 300;
  font-size: 15px;
  text-align: left;
  color: #656565;
  padding: 0px 10px;
}

.nuevo-contenido form input:focus {
  outline: none;
}

.nuevo-contenido form label {
  font-weight: 600;
}

.nuevo-contenido .lugar-posicion {
  display: flex;
}

.nuevo-contenido .lugar-posicion .lugar {
  margin-right: 10px;
}

.nuevo-contenido .lugar-posicion select {
  width: 161px;
  height: 25px;
  background: #eeeeee;
  border: 1px solid #ababab;
  border-radius: 4px;
}

.nuevo-contenido select:focus {
  outline: none;
}

.nuevo-contenido .lugar-posicion input {
  width: 161px;
  height: 25px;
}

.nuevo-contenido .tipo {
  width: 332px;
  height: 25px;
  background: #eeeeee;
  border: 1px solid #ababab;
  border-radius: 4px;
}


.nuevo-contenido .enviar,
.form-wrapper >>> .enviar,
.form-wrapper >>> .enviar button,
.form-wrapper >>> .botones, 
.form-wrapper >>> button.btn-guardar, 
.form-wrapper >>> input[type="submit"] {
  display: none !important;
}


.phase-indicator {
  background: linear-gradient(135deg, #fff9e6 0%, #ffffff 100%);
  border: 2px solid #f8bc02;
  border-radius: 12px;
  padding: 15px 20px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 350px;
  box-shadow: 0 4px 12px rgba(248, 188, 2, 0.15);
}

.phase-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.phase-badge.inherent {
  color: #ff6b6b;
}

.phase-badge.residual {
  color: #51cf66;
}

.phase-badge .phase-text {
  font-family: "Anek Latin", sans-serif;
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
}

.phase-description {
  font-family: "Anek Latin", sans-serif;
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  margin: 0;
  padding-left: 30px;
}

.previous-data-summary {
  background: #f5f5f5;
  border-left: 4px solid #2196f3;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 350px;
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #2196f3;
  font-family: "Anek Latin", sans-serif;
  font-size: 14px;
  font-weight: 700;
}

.summary-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  font-family: "Anek Latin", sans-serif;
  font-size: 13px;
}

.summary-item .label {
  font-weight: 600;
  color: #666;
}

.summary-item .value {
  font-weight: 700;
}

.summary-item .sig-yes {
  color: #ff6b6b;
}

.summary-item .sig-no {
  color: #51cf66;
}

.controls-summary {
  background: #e1f5fe;
  border: 1px solid #81d4fa;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 20px;
  width: 100%;
  max-width: 332px; 
  font-family: "Anek Latin", sans-serif;
  animation: fadeIn 0.5s ease;
}

.summary-list div {
  font-size: 13px;
  color: #444;
  margin-bottom: 4px;
}

/* --- NUEVA ANIMACIÓN DE BRILLO --- */
@keyframes gold-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(248, 188, 2, 0.7);
    transform: scale(1);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(248, 188, 2, 0); /* El anillo se expande y desvanece */
    transform: scale(1.1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(248, 188, 2, 0);
    transform: scale(1);
  }
}

.shining-effect {
  animation: gold-pulse 2s infinite; /* Repite la animación infinitamente */
  background-color: rgba(248, 188, 2, 0.1) !important; /* Un fondo sutil */
  border: 1px solid #f8bc02 !important; /* Borde dorado forzado */
  z-index: 10;
}
</style>